import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Dropdown } from 'components/components/atoms';
import useBreakpoint from 'utils/hooks/useBreakpoint';

const Container = styled.div`
  ${({ isMobile }) => (isMobile ? 'width: 100%;' : 'width: 5.625rem;')}
`;

const TypesList = styled.div`
  display: inline-grid;
  column-gap: 5rem;
`;

const Button = styled.button`
  margin-bottom: 0.5rem;
  &:nth-last-child(1) {
    margin-bottom: 0rem;
  }
`;
const getTypesFiltertoLabel = (typeFilter) => {
  if (typeFilter && typeFilter[0] && typeFilter[0] === 'All') return 'Type';
  let label = '';
  for (let i = 0; i < typeFilter.length; i++) {
    label = label + typeFilter[i];
    if (i < typeFilter.length - 1) label = label + ', ';
  }
  if (label.length <= 13) {
    return label;
  }
  return label.substring(0, 11) + '...';
};
const TypeDropdown = (props) => {
  const {
    options = [],
    onChange,
    value,
    active: activeProp,
    setActive: setActiveProp,
    clearHomeType,
    availableOptions,
  } = props;

  const ref = useRef();
  const [activeState, setActiveState] = useState(false);

  const active = activeProp || activeState;
  const setActive = setActiveProp || setActiveState;

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const filteredOptions = options.filter((t) => t);

  if (filteredOptions.length < 1) {
    return null;
  }

  // Only the types available in the current scope (map viewport / metro) are shown
  const visibleOptions = Array.isArray(availableOptions)
    ? filteredOptions.filter((t) =>
        availableOptions.includes(t.replace(/\s/g, '')),
      )
    : filteredOptions;

  return (
    <Container
      isMobile={isMobile}
      onBlur={() => {
        setTimeout(() => {
          const containsFocusedElement = ref.current.contains(
            document.activeElement,
          );
          if (!containsFocusedElement) {
            setActive(false);
          }
        }, 0);
      }}
      ref={ref}
    >
      <Dropdown
        label={getTypesFiltertoLabel(value)}
        active={active}
        setActive={setActive}
        outlined
        textLightBlue
        small={!isMobile}
        dropdownDescription={`Type Filter: ${
          getTypesFiltertoLabel(value) === 'Type'
            ? 'Select a type to filter the results.'
            : `${getTypesFiltertoLabel(
                value,
              )} selected. Results will filter on the page.`
        }`}
        isTypeDropdown={true}
        withSelectClick={true}
      >
        <TypesList className='bg-white rounded-lg p-2 -mx-2 -my-1'>
          {visibleOptions.length !== 0 ? (
            <Button
              role='checkbox'
              className='relative flex items-center tracking-normal text-sm whitespace-nowrap'
              key={'All'}
              onClick={(e) => {
                onChange('All', true);
                // setActive(false);
              }}
              aria-checked={'All' === value[0]}
            >
              <div
                className={cx('w-4 h-4 mr-2 rounded-full', {
                  'bg-action-blue': 'All' === value[0],
                  'border-2 border-action-blue': 'All' !== value[0],
                })}
              ></div>
              <span className='text-action-blue'>All</span>
            </Button>
          ) : (
            ''
          )}
          {visibleOptions.map((t) => (
            <Button
              role='checkbox'
              className={cx(
                'relative flex items-center tracking-normal text-sm whitespace-nowrap',
                {
                  /* "pointer-events-none": !availableOptions.includes(
                    t.replace(/\s/g, "")
                  ),*/
                },
              )}
              key={t}
              onClick={(e) => {
                onChange(t);
                // setActive(false);
              }}
              aria-checked={value.includes(t)}
            >
              <div
                className={cx('w-4 h-4 mr-2 rounded-full', {
                  'bg-action-blue': value.includes(t),
                  'border-2 border-action-blue': !value.includes(t),
                  /* "border-2 border-mattamy-gray-font": !availableOptions.includes(
                    t.replace(/\s/g, "")
                  ),*/
                })}
              ></div>
              <span
                className={cx('text-action-blue', {
                  /* "text-mattamy-gray-font": !availableOptions.includes(
                    t.replace(/\s/g, "")
                  ),*/
                })}
              >
                {t.length > 30 && isMobile ? t.substring(0, 30) + '...' : t}
              </span>
            </Button>
          ))}
        </TypesList>
        {/* <div className="flex w-full justify-between md:w-auto px-0 my-3">
          <button
            className="flex items-center justify-center border border-white rounded-lg select-none cursor-pointer w-full h-10 md:hover:bg-white md:hover:text-action-blue"
            onClick={clearHomeType}
          >
            Clear
          </button>
        </div> */}
      </Dropdown>
    </Container>
  );
};

export default TypeDropdown;
